import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EventDateTimeProps } from '../../../types';
import { getFormattedDate } from '../../utils/localizedDates';
import './EventHeroDate.scss';

export const EventHeroDate = (props: EventDateTimeProps) => {
    const { hideStartDate, isOnlineEvent, isSeriesParent, locale, start } =
        props;

    if (isSeriesParent) {
        return (
            <p
                data-testid="event-hero-date"
                className="eds-text-bm eds-text-weight--heavy listing-hero-series-parent"
            >
                {gettext('Multiple Dates')}
            </p>
        );
    }

    if (hideStartDate) {
        return null;
    }

    return (
        <p
            data-testid="event-hero-date"
            className="eds-text-bm eds-text-weight--heavy"
            style={{ textTransform: 'capitalize' }}
        >
            {getFormattedDate({
                date: start,
                format: 'MMM DD',
                isOnlineEvent,
                locale,
            })}
        </p>
    );
};

export default EventHeroDate;
